import React from 'react';
import { Empty, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export const EmptyState = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <Empty
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      description={t('Nessuno slider trovato')}
      style={{ padding: '40px 0' }}
    >
   
    </Empty>
  );
}; 